import React, { useState } from "react";
import Modal from "react-modal";
import { Button, TextField, Typography } from "@mui/material";
import { useNavigate } from "react-router";
import { IImovelFocus } from "../../../Pages/Cartorio_Pages/App_Pages/ImovelFocus";
import api from "../../../Services/api";
import theme from "../../../Styles/theme";
import { app_base_url } from "../../../Utils/baseUrl";
import { isRural } from "../../../Utils/isRural";
import { Alert } from "../../Error/Alert";
import { ModalDivX } from "../../ModalDivX";
import { ModalLoader } from "../../ModalLoader";

const QUANTIDADE_MINIMA = 1;
const QUANTIDADE_MAXIMA = 20;

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: theme.colors.secondary,
    minWidth: "40%",
    maxWidth: "80%",
    borderRadius: "0.25rem",
  },
};

interface Props {
  open: boolean;
  onClose(): void;
  imovel: IImovelFocus;
}

export function DuplicarGuiaModal({ open, onClose, imovel }: Props) {
  const navigate = useNavigate();
  const [quantidade, setQuantidade] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({ title: "", message: "" });

  async function duplicar() {
    if (
      !Number.isInteger(quantidade) ||
      quantidade < QUANTIDADE_MINIMA ||
      quantidade > QUANTIDADE_MAXIMA
    ) {
      setError({
        title: "Quantidade inválida",
        message: `Informe um número entre ${QUANTIDADE_MINIMA} e ${QUANTIDADE_MAXIMA}.`,
      });
      return;
    }

    try {
      setLoading(true);
      await api.post(
        `/imovel${isRural() ? "-rural" : ""}/duplicar/${imovel.ID}`,
        { quantidade }
      );
      onClose();
      navigate(`${app_base_url}/imoveis${isRural() ? "-rurais" : ""}`);
    } catch (e) {
      console.log(e);
      setError({
        title: "Não foi possível duplicar a guia!",
        message:
          "Ocorreu um erro ao duplicar a guia, tente novamente mais tarde!",
      });
    } finally {
      setLoading(false);
    }
  }

  return (
    <Modal isOpen={open} onRequestClose={onClose} style={customStyles}>
      <ModalDivX execute={onClose} />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "16px",
          padding: "8px",
        }}
      >
        <Typography variant="h6" align="center">
          Duplicar guia
        </Typography>
        <Typography variant="body2" align="center">
          Informe quantas cópias desta guia você deseja criar. As cópias são
          criadas como pendentes, sem número, envio ou avaliação.
        </Typography>
        <Typography variant="body2" align="center">
          Limitado a {QUANTIDADE_MAXIMA} cópias por vez.
        </Typography>

        <TextField
          type="number"
          label="Quantidade de cópias"
          variant="outlined"
          value={quantidade}
          onChange={(e) => setQuantidade(Number(e.target.value))}
          inputProps={{
            min: QUANTIDADE_MINIMA,
            max: QUANTIDADE_MAXIMA,
            inputMode: "numeric",
          }}
          style={{ background: theme.colors.light, width: "60%" }}
        />

        <Button variant="contained" color="primary" onClick={duplicar}>
          DUPLICAR
        </Button>
      </div>

      <ModalLoader loading={loading} />
      <Alert
        open={error.message.length > 0}
        onClose={() => setError({ title: "", message: "" })}
        title={error.title}
        message={error.message}
      />
    </Modal>
  );
}
